import { render, staticRenderFns } from "./StoresTransactionDetails.vue?vue&type=template&id=1c95ed96&scoped=true&"
import script from "./StoresTransactionDetails.vue?vue&type=script&lang=js&"
export * from "./StoresTransactionDetails.vue?vue&type=script&lang=js&"
import style0 from "./StoresTransactionDetails.vue?vue&type=style&index=0&id=1c95ed96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c95ed96",
  null
  
)

export default component.exports